import { Card, CardBody, CardHeader } from '../ui/card';

export const EXTENSION_HOWTO_ID = 'extension-howto';

/** Step-by-step connect instruction; «Как подключить» on the connect card scrolls here. */
export function ExtensionHowToCard() {
  return (
    <Card id={EXTENSION_HOWTO_ID} tabIndex={-1} aria-labelledby={`${EXTENSION_HOWTO_ID}-title`}>
      <CardHeader className="font-medium" id={`${EXTENSION_HOWTO_ID}-title`}>
        Как подключить расширение
      </CardHeader>
      <CardBody>
        <ol className="list-decimal space-y-1 pl-5 text-sm">
          <li>Установите расширение Outreach Desk в Chrome (файл и инструкцию по установке даёт администратор).</li>
          <li>Откройте vk.com и боковую панель расширения — значок Outreach Desk на панели инструментов Chrome.</li>
          <li>В панели нажмите «Открыть кабинет». Откроется эта страница с запросом на подключение; если потребуется — войдите.</li>
          <li>Нажмите «Подключить расширение» — появится одноразовый код, он действует одну минуту.</li>
          <li>Скопируйте код, вставьте его в поле «Вставьте код» в панели расширения и нажмите «Подключить».</li>
        </ol>
        <p className="mt-3 text-sm text-muted-fg">
          Запрос на подключение действует 10 минут. Если кнопка «Подключить расширение» не появилась — нажмите «Открыть
          кабинет» в панели расширения ещё раз.
        </p>
      </CardBody>
    </Card>
  );
}
